import { ParserWorkerManager } from "../workers/parserWorkerManager";
import { parseAndProcessResponse } from "../utils/parseUtils";

const LARGE_RESPONSE_THRESHOLD = 1 * 1024 * 1024;

export async function parseResponseData(response, options = { flatten: false }) {
  const isLargeResponse = response.size > LARGE_RESPONSE_THRESHOLD;

  let parsed;

  if (isLargeResponse) {
    const worker = new ParserWorkerManager();
    try {
      parsed = await worker.parse(response, options);
    } catch (error) {
      console.error("Worker parsing error:", {
        message: error.message,
        workerError: error.workerError,
        contentType: error.contentType,
        dataPreview: error.originalData?.substring?.(0, 200)
      });

      // fallback to main thread parsing / synchronous parsing
      try {
        parsed = parseAndProcessResponse(response, options);
      } catch (error) {
        return [{
          path: "$",
          value: response.data,
          type: typeof response.data
        }];
      }

    } finally {
      worker.destroy();
    }
  } else {
    // Small response handling
    try {
      parsed = parseAndProcessResponse(response, options);
    } catch (error) {
      return [{
        path: "$",
        value: response.data,
        type: typeof response.data
      }];
    }
  }

  return parsed;
}
